import { CategoryImageInfo, RadioDataItem, RecommendItem } from '@/types/djradio-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DjradioState {
    categories: CategoryImageInfo[]
    currentId: number
    recommends: RecommendItem[]
    radios: RadioDataItem[]
}

const initialState: DjradioState = {
    categories: [],
    currentId: 0,
    recommends: [],
    radios: [],
}

const djradioSlice = createSlice({
    name: 'djradio',
    initialState,
    reducers: {
        changeCategories(state, action: PayloadAction<CategoryImageInfo[]>) {
            state.categories = action.payload
        },
        changeCurrentId(state, action: PayloadAction<number>) {
            state.currentId = action.payload
        },
        changeRecommends(state, action: PayloadAction<RecommendItem[]>) {
            state.recommends = action.payload
        },
        changeRadios(state, action: PayloadAction<RadioDataItem[]>) {
            state.radios = action.payload
        },
    },
})

export const { changeCategories, changeCurrentId, changeRecommends, changeRadios } = djradioSlice.actions

export default djradioSlice.reducer
